const SESSION_STORAGE_KEYS = {
    ACTED_PATTERNS: 'actedPatterns',
    WANTED_URL: 'wantedURL',
}

class _SessionStorageService {
    getActedPatterns() {
        return JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEYS.ACTED_PATTERNS))
    }

    addActedPattern(layerId, patternId) {
        let actedPatterns = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEYS.ACTED_PATTERNS))
        if (actedPatterns) {
            const isPatternExists = actedPatterns.some(
                pattern => pattern.layerId === layerId && pattern.patternId === patternId,
            )

            if (!isPatternExists) {
                actedPatterns.push({ layerId, patternId })
            }
        } else {
            actedPatterns = [{ layerId, patternId }]
        }

        sessionStorage.setItem(SESSION_STORAGE_KEYS.ACTED_PATTERNS, JSON.stringify(actedPatterns))
    }

    getWantedURL() {
        return JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEYS.WANTED_URL))
    }

    setWantedURL(newURL) {
        sessionStorage.setItem(SESSION_STORAGE_KEYS.WANTED_URL, JSON.stringify(newURL))
    }
}

const SessionStorageService = new _SessionStorageService()
export default SessionStorageService
